import {getEnv} from '../../common/env/env';
import {ShortVodPreviewViewerInfoVo} from '../../common/shared/api/gateway/viewer/ShortVodPreviewViewerInfoVo';
import {
  DrmServerType,
  ShortVodPreviewViewerInfo,
  VodViewerData,
} from '../generated/types';
import {createSeries} from './Series';
import {createSingle} from './Single';
import {createViewerData} from './ViewerData';

export function createShortVodPreviewViewerInfo({
  item,
  series_item,
  viewer_data,
  video_token,
}: ShortVodPreviewViewerInfoVo): ShortVodPreviewViewerInfo {
  const data: ShortVodPreviewViewerInfo = {
    item: createSingle(item),
    seriesItem: createSeries(series_item),
    viewerData: createViewerData(viewer_data) as VodViewerData,
  };

  if (viewer_data && 'vod_download_data' in viewer_data) {
    if (data.viewerData && video_token) {
      data.viewerData.drmInfo =
        video_token.provider === 'inisoft'
          ? {
              serverType: DrmServerType.Ini,
              assertion: video_token.token,
              widevineLicenseUrl: getEnv().iniWidevineLicenseServerUrl,
              fairplayLicenseUrl: getEnv().iniFairplayLicenseServerUrl,
              fairplayCertificateUrl:
                'https://fairplay-cert.kakaoent.com/fairplay/fairplay.cer?20190115',
            }
          : {
              serverType: DrmServerType.Page,
              token: video_token.token,
              provider: video_token.provider,
              widevineLicenseUrl: `${getEnv().drmServerHost}/v1/license`,
              fairplayLicenseUrl: `${getEnv().drmServerHost}/v1/license`,
              fairplayCertificateUrl:
                'https://fairplay-cert.kakaoent.com/fairplay/fairplay.cer?20190115',
            };
    }
  }
  return data;
}
